import I18n from 'i18n-js';
import i18nliner from 'i18nliner/dist/lib/extensions/i18n_js';
import reactI18nliner from 'react-i18nliner/dist/extensions/i18n_js';

i18nliner(I18n);
reactI18nliner(I18n);

export default I18n;
